module.exports = __webpack_public_path__ + "static/media/story_09.889fa3cb.jpg";